import React from 'react';
import {connect} from 'react-redux';
import {change, Field} from "redux-form";
import {FormattedMessage, injectIntl} from "react-intl";

import ExpandSection from "../../Generic/expandSection";
import {
  setBillingInformation,
  setPaymentGatewayInfo, toggleCreditCardPopup,
  togglePaymentGatewayPopup,
  toggleSectionOpened
} from "../AccountActions";
import {ACCOUNT_SECTIONS} from "./sectionNames";
import {FormCheckBoxField, FormField, required} from "../FormField";
import {loadPaymentGateways} from "../../AddNewEntity/AddNewEntityActions";
import {store} from "../../../main";
import {setUiPopupState} from "../../../actions/A_Popups";
import AddACHButton from "../ACHComponents/AddACHButton";

class BillingInformation extends React.Component {

  componentDidMount() {
    this.setPaymentGatewayInfo()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.formValues) {
      const {ccName, ccNum} = nextProps.billingInformation;
      if (!ccName && nextProps.formValues.billingAddress && nextProps.formValues.billingAddress.name) {
        this.props.setBillingInformation({ccName: nextProps.formValues.billingAddress.name})
      }
      if (!ccNum && nextProps.formValues.paymentProfile && nextProps.formValues.paymentProfile.paymentProfiles
        && nextProps.formValues.paymentProfile.paymentProfiles.length) {
        this.props.setBillingInformation({
          ccNum: nextProps.formValues.paymentProfile.paymentProfiles[0].payment.creditCard.cardNumber
        })
      }
    }
  }

  setPaymentGatewayInfo = (showPopup = false) => {
    const {entityId} = this.props.accountPageInfo;
    if (entityId) {
      this.props.loadPaymentGateways(entityId)
        .then((res) => {
          this.props.setPaymentGatewayInfo({
            paymentGateway_MxMerchant_MerchantId: (res && res.mxMerchant && res.mxMerchant.merchantId) || '',
            paymentGateway_MxMerchant_ApiKey: (res && res.mxMerchant && res.mxMerchant.apiKey) || '',
            paymentGateway_MxMerchant_ApiSecret: (res && res.mxMerchant && res.mxMerchant.apiSecret) || '',
            paymentGateway_MxMerchant_NachaId: (res && res.mxMerchant && res.mxMerchant.nachaId) || '',
            paymentGateway_MxMerchant_TestMode: (res && res.mxMerchant && res.mxMerchant.testMode) || '',
            paymentGateway_AuthNet_ApiLogin: (res && res.authorizeNet && res.authorizeNet.apiLoginId) || '',
            paymentGateway_AuthNet_TransactionKey: (res && res.authorizeNet && res.authorizeNet.transactionKey) || '',
            paymentGateway_AuthNet_TestMode: (res && res.authorizeNet && res.authorizeNet.testMode) || false,
            paymentGateway_AuthNet_customEndpointUrl: (res && res.authorizeNet && res.authorizeNet.customEndpointUrl) || ''
          });
          this.props.togglePaymentGatewayPopup(showPopup)
        });
    }
  }

  updateCheckBoxField = (input) => {
    store.dispatch(change('newEntity', input.name, !input.value));
    if (!input.value) {
      if (!this.props.formValues.shippingAddress) {
        store.dispatch(change('newEntity', "shippingAddress", {}));
      }
      ["name", "address1", "address2", "city", "state", "zip"].forEach((key) => {
        if (this.props.formValues.shippingAddress) {
          store.dispatch(change('newEntity', "billingAddress."+key, this.props.formValues.shippingAddress[key]));
        }
      })
    }
  };

  updateBillingAddress = (event) => {
    // store.dispatch(change('newEntity', input.name, input.value)); it already updates by redux form
    if (this.props.formValues.billingSameAsShipping) {
      const name = "shippingAddress."+(event.target.name.split("billingAddress.")[1]);
      store.dispatch(change('newEntity', name, event.target.value));
    }
  };

  render() {

    const {intl} = this.props;
    const {entityId, isFabricator, isCustomer, canEditFields} = this.props.accountPageInfo;
    const paymentProfile = this.props.customerInfo || {};
    const {saveCC} = this.props.billingInformation;

    return (
      <ExpandSection opened={this.props.sectionsOpened.includes(ACCOUNT_SECTIONS.billing_information)}
                     onClick={() => this.props.toggleSectionOpened(ACCOUNT_SECTIONS.billing_information)}
                     title={intl.formatMessage({id: "account.billingInformation.sectionTitle"})}>
        <div className="acc-container">
          <div className="acc-container__row">
            <div className="acc-block">
              <Field name="billingSameAsShipping" component={FormCheckBoxField}
                     disabled={!canEditFields}
                     labelEnabled={intl.formatMessage({id: "account.billingInformation.sameAsBusiness"})}
                     labelDisabled={intl.formatMessage({id: "account.billingInformation.sameAsBusiness"})}
                     doubleMargin={true} onChecked={this.updateCheckBoxField}/>
              <Field name="billingAddress.name"
                     component={FormField}
                     label={intl.formatMessage({id: "account.billingInformation.nameOnCard"})}
                     disabled={!canEditFields}
                     onChange={(e, value) => {
                       this.updateBillingAddress(e);
                       this.props.setBillingInformation({ccName: value})
                     }}/>
              <Field name="billingAddress.address1" component={FormField}
                     onChange={this.updateBillingAddress}
                     label={`${intl.formatMessage({id: "account.billingInformation.address1"})} ${isCustomer ? '*' : ''}`}
                     validate={isCustomer ? required : null}
                     disabled={!canEditFields}/>
              <Field name="billingAddress.address2"
                     component={FormField}
                     labelEnabled={intl.formatMessage({id: "account.billingInformation.address2"})}
                     label="Address 2"
                     disabled={!canEditFields}
                     onChange={this.updateBillingAddress}/>
              <div className="acc-three">
                <div className="acc-three__item">
                  <Field name="billingAddress.city"
                         component={FormField}
                         label={`${intl.formatMessage({id: "account.billingInformation.city"})} ${isCustomer ? '*' : ''}`}
                         validate={isCustomer ? required : null}
                         onChange={this.updateBillingAddress}
                         disabled={!canEditFields}/>
                </div>
                <div className="acc-three__item">
                  <Field name="billingAddress.state"
                         component={FormField}
                         label={`${intl.formatMessage({id: "account.billingInformation.state"})} ${isCustomer ? '*' : ''}`}
                         validate={isCustomer ? required : null}
                         onChange={this.updateBillingAddress}
                         disabled={!canEditFields}/>
                </div>
                <div className="acc-three__item">
                  <Field name="billingAddress.zip"
                         component={FormField}
                         label={`${intl.formatMessage({id: "account.billingInformation.zipCode"})} ${isCustomer ? '*' : ''}`}
                         validate={isCustomer ? required : null}
                         onChange={this.updateBillingAddress}
                         disabled={!canEditFields}/>
                </div>
              </div>
            </div>
            <div className="acc-block">
              {isFabricator && canEditFields && this.props.subscriptions.length >= 1 ? (
                <div className="acc-block2">
                  <div className="pl-2 pr-2 border-box flex flex--center">
                    <div className="acc-block2__item">
                      <span className="ui-button2 ui-button2--blue"
                            onClick={() => this.props.toggleCreditCardPopup(true)}>
                        <FormattedMessage id={
                          saveCC || paymentProfile.customerProfileId
                            ? "account.billingInformation.updateCreditCard"
                            : "account.billingInformation.addCreditCard"
                        }/>
                      </span>
                    </div>
                  </div>
                  {entityId && paymentProfile ? (
                    <div className="acc-block2__item acc-block2__item--with-left-line flex flex--center">
                      <div className="pl-2 pr-2 border-box flex flex--column">
                        <div className="ui-button2 ui-button2--blue"
                             onClick={() => this.setPaymentGatewayInfo(true)}>
                          <FormattedMessage id="account.billingInformation.addPaymentGateway"/>
                        </div>
                        <AddACHButton/>
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </ExpandSection>
    )
  }

}

const mapStateToProps = (store) => {
  const {sectionsOpened, accountPageInfo, billingInformation} = store.accountState;
  const {customerInfo} = store.newaccount;
  return {
    sectionsOpened,
    accountPageInfo,
    customerInfo,
    billingInformation,
    formValues: (store.form && store.form.newEntity && store.form.newEntity.values) || {
      customerProfileId: null
    },
    subscriptions: store.newaccount.subscriptions
  };
};

const mapDispatchToProps = {
  toggleSectionOpened,
  setBillingInformation,
  setPaymentGatewayInfo,
  loadPaymentGateways,
  togglePaymentGatewayPopup,
  toggleCreditCardPopup,
  setUiPopupState,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(BillingInformation)
);

